/**
* Logo Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {

    className: 'logo-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logo-slider__splide' ).each( function( key, component ) {
        const logoSlider = new Splide( component, {
          type: 'loop',
          perPage: 1,
          perMove: 1,
          gap: '80px',
          pagination: false,
          autoplay: true,
          speed: 800,
          fixedWidth: '350px',
        } );


        logoSlider.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-slider', COMPONENT );
} )( app );
